import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "multiselect-tag is-user" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onMousedown"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "multiselect-tag-remove-icon" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  tabindex: "0",
  role: "button",
  "data-clear": "",
  "aria-roledescription": "❎",
  class: "multiselect-clear"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "multiselect-clear-icon" })
], -1)
const _hoisted_8 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Multiselect, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      mode: _ctx.mode,
      placeholder: _ctx.placeholder,
      closeOnSelect: _ctx.closeOnSelect,
      canClear: _ctx.canClear,
      searchable: _ctx.searchable,
      trackBy: _ctx.trackBy,
      label: _ctx.label,
      options: _ctx.options,
      onSelect: _ctx.changeValue,
      disabled: _ctx.Disabled
    }, {
      tag: _withCtx(({ option, handleTagRemove, disabled }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: option.image
          }, null, 8, _hoisted_2),
          _createTextVNode(" " + _toDisplayString(option.name) + " ", 1),
          (!disabled)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "multiselect-tag-remove",
                onMousedown: _withModifiers(($event: any) => (_ctx.Remove(handleTagRemove(option, $event))), ["prevent"])
              }, _hoisted_5, 40, _hoisted_3))
            : _createCommentVNode("", true)
        ])
      ]),
      option: _withCtx(({ option }) => [
        _createElementVNode("img", {
          class: "user-image",
          src: option.image
        }, null, 8, _hoisted_6),
        _createTextVNode(" " + _toDisplayString(option.name), 1)
      ]),
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }, 8, ["modelValue", "mode", "placeholder", "closeOnSelect", "canClear", "searchable", "trackBy", "label", "options", "onSelect", "disabled"]),
    (_ctx.HasError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "承認者を一人は選択してください"))
      : _createCommentVNode("", true)
  ], 64))
}